  routerConfig.$inject = [
    '$stateProvider'
  ];

  export default function routerConfig($stateProvider) {

    $stateProvider
    .state({
      name: 'login',
      parent: 'app',
      url: '/login/:storeName',
      params: {
        productId: '',
        categoryId: '',
        subCategoryId : ''
      },
      views: {
        'content@app': {
          template: '<login></login>'
        }
      },
      resolve: {
        nonLoggedInOnly: ['authService', function(authService) {
          return authService.nonLoggedInOnly();
        }]
      }
    })

    .state({
      name: 'signup',
      parent: 'app',
      url: '/signup/:storeName?email',
      reloadOnSearch: false,
      views: {
        'content@app': {
          template: '<signup></signup>'
        }
      },
      resolve: {
        nonLoggedInOnly: ['authService', function(authService) {
          return authService.nonLoggedInOnly();
        }]
      }
    })

    .state({
      name: 'auth',
      parent: 'app',
      url: '/auth',
      abstract: true,
      views: {
        'header@app': {
          template: '<auth-header></auth-header>'
        }
      }
    })

    .state({
      name: 'tnc',
      parent: 'auth',
      url: '/terms-and-conditions',
      views: {
        'content@app': {
          template: '<terms-conditions></terms-conditions>'
        }
      },
      resolve: {
        nonLoggedInOnly: ['authService', function(authService) {
          return authService.nonLoggedInOnly();
        }]
      }
    })
    .state({
      name: 'rules',
      parent: 'auth',
      url: '/rules',
      views: {
        'content@app': {
          template: '<rules-faq></rules-faq>'
        }
      },
      resolve: {
        nonLoggedInOnly: ['authService', function(authService) {
          return authService.nonLoggedInOnly();
        }]
      }
    })
    .state({
      name: 'cawarn',
      parent: 'auth',
      url: '/cawarn',
      views: {
        'header@app': {
          template: '<header></header>'
        },
        'sidenav@app': {
          template: '<sidenav></sidenav>'
        },
        'content@app': {
          template: '<ca-warn></ca-warn>'
        }
      },
      resolve: {
        nonLoggedInOnly: ['authService', function(authService) {
          return authService.nonLoggedInOnly();
        }]
      }
    })
    .state({
      name: 'birds-critters',
      parent: 'rules',
      url: '/birds-and-critters',
      views: {
        'content@app': {
          template: '<birds-critters></birds-critters>'
        }
      }
    })
    .state({
      name: 'franchising',
      parent: 'rules',
      url: '/franchising',
      views: {
        'content@app': {
          template: '<franchising></franchising>'
        }
      }
    })
    .state({
      name: 'product-warranties',
      parent: 'rules',
      url: '/product-warranties',
      views: {
        'content@app': {
          template: '<product-warranties></product-warranties>'
        }
      }
    })

    .state({
      name: 'forgotPassword',
      parent: 'auth',
      url: '/forgot-password',
      views: {
        'content@app': {
          template: '<forgot-password></forgot-password>'
        }
      },
      resolve: {
        nonLoggedInOnly: ['authService', function(authService) {
          return authService.nonLoggedInOnly();
        }]
      }
    })
    .state({
      name: 'resetPassword',
      parent: 'auth',
      url: '/account/password/reset/:storeName/:id/*token',
      views: {
        'content@app': {
          template: '<reset-password></reset-password>'
        }
      },
      resolve: {
        nonLoggedInOnly: ['authService', function(authService) {
          return authService.nonLoggedInOnly();
        }]
      }
    })
    .state({
      name: 'activate',
      parent: 'auth',
      url: '/account/activate/:storeName/:id/*token',
      views: {
        'content@app': {
          template: '<activate></activate>'
        }
      },
      resolve: {
        nonLoggedInOnly: ['authService', function(authService) {
          return authService.nonLoggedInOnly();
        }]
      }
    })
    .state({
      name: 'inactive',
      parent: 'auth',
      url: '/account/inactive',
      views: {
        'content@app': {
          template: '<inactive></inactive>'
        }
      },
      resolve: {
        nonLoggedInOnly: ['authService', function(authService) {
          return authService.nonLoggedInOnly();
        }]
      }
    })
    .state({
      name: 'otpactivate',
      parent: 'auth',
      url: '/account/otpactivate/:storeName/:id',
      params: {
        email: null
      },
      views: {
        'content@app': {
          template: '<otpactivate></otpactivate>'
        }
      },
      resolve: {
        nonLoggedInOnly: ['authService', function(authService) {
          return authService.nonLoggedInOnly();
        }]
      }
    })
    .state({
      name: 'cancelsubscription',
      parent: 'auth',
      url: '/subcription/cancel/:storeName/:token',
      views: {
        'content@app': {
          template: '<subscription-email></subscription-email>'
        }
      },
      resolve: {
        nonLoggedInOnly: ['authService', function(authService) {
          return authService.nonLoggedInOnly();
        }]
      }
    })
     .state({
      name: 'modifysubscription',
      parent: 'auth',
      url: '/subcription/modify/:storeName/:token',
      views: {
        'content@app': {
          template: '<subscription-modify></subscription-modify>'
        }
      },
      resolve: {
        nonLoggedInOnly: ['authService', function(authService) {
          return authService.nonLoggedInOnly();
        }]
      }
    })
    ;
  }



// WEBPACK FOOTER //
// ./src/app/auth/router.js